import { useEffect, useState } from 'react';

/**
 * An object URL for a blob, created on effect mount and revoked on cleanup.
 * NEVER useMemo: StrictMode re-runs cleanups without re-running memos, so a
 * memoized URL is revoked while the <img> still points at it.
 */
export function useObjectUrl(blob: Blob | null | undefined): string | null {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    if (!blob) return; // the previous effect's cleanup already reset the state
    const next = URL.createObjectURL(blob);
    // The URL's lifetime must equal the effect's — see above.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setUrl(next);
    return () => {
      URL.revokeObjectURL(next);
      setUrl(null);
    };
  }, [blob]);
  return url;
}
